"use client";
import { RefObject, useCallback, useEffect, useRef } from "react";
import { View } from "react-native";

export default function useOnClickOutside(
  ref: RefObject<View>,
  handler: Function
) {
  const handlerRef = useRef(handler);

  const handleClickOutside = useCallback(
    (e: MouseEvent | TouchEvent) => {
      if (
        ref.current &&
        // The outside react native ref is using View, but in react-native-web/react we use Node instead
        !(ref.current as unknown as Node).contains(e.target as Node)
      ) {
        handlerRef.current();
      }
    },
    [ref]
  );

  useEffect(() => {
    handlerRef.current = handler;
  });

  const deps = !handler;
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside, false);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside, false);
    };
  }, [deps, handleClickOutside]);
}
